<template>
  <div class="header">
      <!-- <a v-if="logged_role!='company' && logged_role!='sadmin'" href="/" class="title_link">
        <img src="../../assets/menu_logo.png" style="height:40px;padding-top:13px;margin-left:20px;" />
        <span style="position:relative;bottom:10px;left:5px;">管理基本功评估系统</span>
      </a> -->
      <!-- company和sadmin用户取消首页链接 -->
      <a v-if="logged_role!='admin' && logged_role!='sadmin'" class="title_link" style="text-decoration:none;" href="/glyf">
        <img src="../../assets/glyf_logo.jpg" style="height:70px;" />
        <span style="position:relative;bottom:25px;left:15px;">管理有方 | 管理痛点库</span>
      </a>
      <a v-else class="title_link" style="text-decoration:none;">
        <img src="../../assets/glyf_logo.jpg" style="height:70px;" />
        <span style="position:relative;bottom:25px;left:15px;">管理有方 | 管理痛点库</span>
      </a>
      <div class="log_main">
        <div class="log_left">
            <span v-if="logged_role!='guest'">你好，{{ logged_user }}</span>
            <!-- <span v-else>你好，<a href="/glyf_login" style="font-size:16px;color:#E6A23C;text-decoration:unset;">请登录</a></span> -->
        </div>
        <div class="log_right" v-if="logged_role!='guest'">
            <el-dropdown placement="top-start" @command="handleCommand">
                <span class="el-dropdown-link">
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <!-- <el-dropdown-item icon="el-icon-edit" command="chg_passwd" v-if="this.logged_role=='admin'">修改密码</el-dropdown-item> -->
                    <!-- <el-dropdown-item icon="el-icon-edit" command="chg_passwd">修改密码</el-dropdown-item> -->
                    <el-dropdown-item icon="el-icon-setting" command="user_center" v-if="logged_role!='admin' && logged_role!='sadmin'">个人中心</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-edit" command="chg_passwd">修改密码</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-user" command="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-dialog :title="chg_passwd_title" :visible.sync="dialogFormVisible" width="400px" :destroy-on-close="true" :close-on-click-modal="false" :show-close="false">
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="当前密码" prop="old_passwd">
                        <el-input v-model="form.old_passwd" type="password" placeholder="请输入当前密码" show-password></el-input>
                    </el-form-item>
                    <el-form-item label="新密码" prop="new_passwd">
                        <el-input v-model="form.new_passwd" type="password" placeholder="请输入新密码" show-password></el-input>
                    </el-form-item>
                    <div style="text-align:center;line-height:40px;">
                        <el-button @click="cancle_chg">取 消</el-button>
                        <el-button type="primary" @click="submit_chg">确 定</el-button>
                    </div>
                </el-form>
            </el-dialog>
        </div>
      </div>
  </div>
</template>

<script>
import getdata from "@/api/getData.js";
import postdata from "@/api/postData.js";
// import chgPasswd from "./ChgPasswd.vue";
export default {
    created(){
        // 从后台获取用户类型，以便按照用户类型展示对应的菜单项
        let params = {
            task_type: "GLYF",
        }
        getdata.getListP("checklogin", params)
              .then(resp => {
                    this.logged_role = resp.data.usertype;
                    this.logged_user = resp.data.username;
                    if(this.logged_role=='guest'){
                        this.$router.push({
                            path: '/glyf_login',
                        });
                    }
              })
              .catch(() => {
                    // this.logged_role = 'guest';
                    // this.logged_user = 'guest';
                    this.$router.push({
                        path: '/glyf_login',
                    });
              })
        // 根据当前的路由信息，标识对应的菜单项（主要为了防止刷新页面后不显示当前选中的菜单项）
        // this.activeIndex = this.$route.path;  
        // 增加对带参数的路由的判断
        // if(this.$route.path.includes('/taskmgmt')) {
        //     this.activeIndex = '/tasks';
        // }
        // console.log("active index: " + this.activeIndex);
        // 检查用户是否已修改密码，未修改则弹出修改密码窗口
        getdata.getList("checkPassMod")
            .then(resp => {
                if(resp.data.code != 200){
                this.chg_passwd_title = '首次登录或重置密码后，请修改密码，谢谢！';
                this.dialogFormVisible = true;
                this.$message({
                    message: resp.data.message,
                    type: 'warning',
                    duration: 4000,
                })
                }
            })
            .catch(() => {

            })
    },
    // beforeMount() {
    //     // this.$router.push({
    //     //     path: this.$route.path,
    //     // })
    //     console.log("active path: " + this.$route.path);
    //     this.activeIndex = this.$route.path;
    //     console.log("active index: " + this.activeIndex);
    // },
    data() {
        return {
            logged_user: '',
            logged_role: '',
            chengshu_name: '管理成熟度测评',
            jiankang_name: '组织健康度测评',
            activeIndex: '',
            dialogFormVisible: false,
            chg_passwd_title: '修改密码',
            form: {
              old_passwd: '',
              new_passwd: '',
            },
        }
    },
    methods: {
        cancle_chg() {
            this.dialogFormVisible = false;
            // 增加处理：初始登录未修改密码直接取消修改密码时，则退回到登录页面
            getdata.getList("checkPassMod")
              .then(resp => {
                  if(resp.data.code != 200){
                    this.$router.push({
                        path: '/glyf_login',
                    });
                  }
              })
              .catch(() => {

              })           
        },
        submit_chg() {
            postdata.postList("chgPasswd", JSON.stringify(this.form))
              .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                        message: resp.data.message,
                        type: 'success',
                        duration: 2500,
                    })
                    this.chg_passwd_title = '修改密码';
                    this.dialogFormVisible = false;
                    // 修改密码后，强制退出并要求重新登录
                    this.$router.push({
                        path: '/glyf_login',
                    });
                }else{
                    this.form.old_passwd = '';
                    this.form.new_passwd = '';
                    this.$message({
                        message: resp.data.message,
                        type: 'error',
                        duration: 2000,
                    })
                }
              })
              .catch(err => {
                console.log(err);
              })
        },
        handleCommand(command) {
            switch(command){
                case 'user_center':
                    this.$router.push({
                        path: '/glyf_user_center',
                    });
                    break;
                case 'chg_passwd':
                    this.dialogFormVisible = true;
                    break;
                case 'logout':
                    getdata.getList("logout")
                        .then(resp => {
                            if(resp.data.code == 200){
                                this.$message({
                                    message: '已登出！',
                                    type: 'success',
                                })
                                localStorage.removeItem('username');
                                localStorage.removeItem('token');
                                this.$router.push({
                                    path: '/glyf_login',
                                })  
                            }
                        })
                        .catch(() => {
                            this.$message({
                                message: '操作失败！',
                                type: 'error',
                            })
                        })
                    break;
                default:
                    break;
            }
        },
    }
}
</script>


<style scoped>
.header {
    display: flex;
    /* position: absolute; */
    height: 70px;
    line-height: 70px;
    background-color: #545C64;
    /* left: 0px;
    right: 0px;
    top: 0px; */
    color: white;
    text-align: left;
    /* padding-top: 2px; */
    /* min-width: 1430px; */
    min-width: 1080px;
}
.title_link {
    text-decoration: unset;
    font-size: 27px;
    color: white;
    display: block;
    height: 70px;
    line-height: 70px;
    width: 340px;
}
.title {
    color: #fff;
    padding-left: 5px;
    font-size: 25px;
}
.log_main {
    position: absolute;
    top: 0px;
    left: 400px;
    /* float: right; */
    right: 0px;
}
.el-menu {
    border-bottom: none;
}
.single_menu {
    width: 140px;
    padding-left: 30px;
}
.el-menu-item {
    font-size: 20px;
    line-height: 70px;
    height: 67px;
}
.el-submenu /deep/ .el-submenu__title {
    font-size: 20px;
    line-height: 70px;
    height: 67px;
}
/* .sub_menu /deep/ .el-submenu__title {
    line-height: 36px;
    height: 36px;
} */
.log_left {
    /* float: left;
    margin-left: 2%;
    margin-right: 10px; */
    position: absolute;
    top: 0;
    right: 100px;
}
.log_left span {
    /* cursor: pointer; */
    color: white;
    font-size: 15px;
}
/* .log_left span:hover {
    color: rgb(255, 208, 75);
} */
.log_right {
    /* float: left; */
    position: absolute;
    top: 0;
    right: 20px;
}
/* .unlogin {
    cursor: pointer;
    float: right;
    margin-right: 50px;
    font-size: 16px;
    color: #fff;
} */

/* .unlogin:hover {
    text-decoration: underline;
} */
.el-dropdown-link {
    cursor: pointer;
    color: #fff;
}
.el-icon-arrow-down {
    font-size: 16px;
}
.el-dropdown {
    float: right;
    margin-right: 50px;
}
::v-deep .el-table__header {
    font-size: 16px;
}
::v-deep .el-dialog__header {
    line-height: 0px;
}
::v-deep .el-dropdown-menu__item {
    width: 80px;
}
</style>